let container = document.querySelector('.image-wrap');
let oldContainerWidth = container.offsetWidth;
let swatchWidth = 34;
let oldNumberOfSwatches = Math.floor(oldContainerWidth / swatchWidth) - 1;
let newNumberOfSwatches = oldNumberOfSwatches;

const swatches = document.querySelectorAll('.color-swatch');
let gridContainer = document.querySelector('.collection-grid__wrapper');

window.addEventListener('resize', ()=> {
  let newContainerWidth = container.offsetWidth;
  if (Math.abs(oldContainerWidth - newContainerWidth) > swatchWidth) {
    oldContainerWidth = newContainerWidth;
    newNumberOfSwatches = Math.floor(newContainerWidth / swatchWidth) - 1;
    if (newNumberOfSwatches !== oldNumberOfSwatches) {
      showAndHideSwatches();
      oldNumberOfSwatches = newNumberOfSwatches;
    }
  }
});

document.addEventListener('collection:reloaded', function() {
  container = document.querySelector('.image-wrap');
  gridContainer = document.querySelector('.collection-grid__wrapper');
  
  clickableSwatches();
  showAndHideSwatches();
});

showAndHideSwatches();
clickableSwatches();

function clickableSwatches() {
  
  gridContainer.addEventListener('click', (e) => {
    if (e.target.classList.contains('color-swatch')) {
      let previousSwatch = e.target.parentNode.querySelector('.active');
      if (e.target !== previousSwatch) {
        e.target.classList.add('active');
        previousSwatch.classList.remove('active');
        previousSwatch = e.target;
      }
      
      const newPrice = e.target.dataset.swatchPrice;
      const newComparePrice = e.target.dataset.swatchComparePrice;
      const rawPrice = parseFloat(newPrice?.replace(/[^0-9.]/g, '') || 0);
      const rawComparePrice = parseFloat(newComparePrice?.replace(/[^0-9.]/g, '') || 0);

      const newUrl = e.target.dataset.swatchUrl;
      const newSrc = e.target.dataset.swatchSrc;
      const newTitle = e.target.dataset.swatchTitle;
  
      const imageWrapper = e.target.parentNode.previousElementSibling;
      const imageLink = imageWrapper.querySelector('a');
      const image = imageWrapper.querySelector('.image-wrap img');
      
      image.src = newSrc;
      image.srcset = `${newSrc}&width=360 360w, ${newSrc}&width=540 540w, ${newSrc}&width=720 720w, ${newSrc}&width=900 900w, ${newSrc}&width=1080 1080w`;
      image.alt = newTitle;
      imageLink.href = newUrl;
  
      const imageTitle = imageWrapper.querySelector('.grid-product__title');
      imageTitle.textContent = newTitle;

      // Sale price, compare price, and sale tag update
      const isOnSale = newComparePrice && rawComparePrice > rawPrice;
      const priceWrapper = imageWrapper.querySelector('.grid-product__price');
      
      if (priceWrapper && newPrice) {
        if (isOnSale) {
          let savings = Math.round((rawComparePrice - rawPrice) / rawComparePrice * 100);
          priceWrapper.innerHTML = `
            <span class="visually-hidden">Regular price</span>
            <span class="grid-product__price--original">${newComparePrice}</span>
            <span class="visually-hidden">Sale price</span>
            <span class="grid-product__sale-price">${newPrice}</span>
            <span class="grid-product__price--savings">Save ${savings}%</span>
          `;
        } else {
          priceWrapper.textContent = newPrice;
        }
      }
      let saleTag = imageWrapper.querySelector('.grid-product__tag--sale');
      
      let soldOutTag = imageWrapper.querySelector('.grid-product__tag--sold-out');
      if (soldOutTag) {
        e.target.classList.contains('disabled') ? soldOutTag.classList.remove('hide') : soldOutTag.classList.add('hide');
      } else if (!soldOutTag && e.target.classList.contains('disabled')) {
        soldOutTag = `<div class="grid-product__tag grid-product__tag--sold-out">Available Soon</div>`;
        imageWrapper.insertAdjacentHTML('afterbegin', soldOutTag);
      } else if (isOnSale && !saleTag) {
        imageWrapper.insertAdjacentHTML('afterbegin', `<div class="grid-product__tag grid-product__tag--sale">Sale</div>`);
      } else if (!isOnSale && saleTag) {
        saleTag.remove();
      }
    }
  });
}


function showAndHideSwatches() {
  const swatchContainers = document.querySelectorAll('.grid-product__colors');
  swatchContainers.forEach((swatchContainer) => {
      const totalNumberOfSwatches = swatchContainer.querySelectorAll('button').length;
      const numberOfSwatchesToHide = Math.abs(totalNumberOfSwatches - newNumberOfSwatches);
      if (totalNumberOfSwatches > newNumberOfSwatches && newNumberOfSwatches <= oldNumberOfSwatches) {
        for (let i = totalNumberOfSwatches - 1; i >= newNumberOfSwatches; i--) {
          swatchContainer.children[i].classList.add('hide');
        }
        swatchContainer.lastElementChild.textContent = `+${numberOfSwatchesToHide}`
        swatchContainer.lastElementChild.setAttribute('aria-label', `View ${numberOfSwatchesToHide} other colors`);
      } else if (totalNumberOfSwatches <= newNumberOfSwatches) {
        for (let i = 0; i < totalNumberOfSwatches; i++) {
          swatchContainer.children[i].classList.remove('hide');
        }
        swatchContainer.lastElementChild.textContent = '';
      } else if (totalNumberOfSwatches > newNumberOfSwatches && newNumberOfSwatches > oldNumberOfSwatches) {
        for (let i = oldNumberOfSwatches; i < newNumberOfSwatches; i++) {
          swatchContainer.children[i].classList.remove('hide');
        }
        swatchContainer.lastElementChild.textContent = `+${numberOfSwatchesToHide}`
        swatchContainer.lastElementChild.setAttribute('aria-label', `View ${numberOfSwatchesToHide} other colors`);
      }
  });
}



